import { Stack } from "@mui/material";
import React from "react";

export const ByBoardHeader = ({ handleExpandAll, checked }) => {
  return (
    <>
      <div className="worklog_board_header">
        <p className="font-bold">Board Name</p>
        <Stack direction={"row"} alignItems={"center"}>
          <p className="font-bold">Hours</p>
          <div className="w-25 text-end">
            <label class="custom-checkbox">
              <input
                type="checkbox"
                id={`expand-all-checkbox`}
                onClick={handleExpandAll}
                checked={checked}
              />
              <span class="checkmark"></span>
              <p className="team-status-title">Expand-All</p>
            </label>
          </div>
        </Stack>
      </div>
    </>
  );
};
